import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Container } from 'components/layout/Grid/'
import PartnerHierarchyForm from 'containers/PartnerHierarchyForm'
import PartnerPlanStatusForm from 'containers/PartnerPlanStatusForm'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import { resetErrorMessage, setErrorMessage } from 'actions/app'
import { modalShow, modalHide } from 'actions/modals'
import { getPersonalInfos, setStatusFilter, setCodeFilter, setLocationFilter, setSelectedPartner } from 'actions/personalInfos'
import { getMyPartnerPlans } from 'actions/partnerPlans'
import { loadSelectedPartnerHierarchy } from 'actions/partnerHierarchyForm'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import MainLayout from 'components/MainLayout'
import { hasAccess } from 'utils/hasAccess'
import constants from 'constants'

class PersonalInfos extends Component {
  static propTypes = {
    currentUser: PropTypes.object,
    getMyPartnerPlans: PropTypes.func.isRequired,
    getPersonalInfos: PropTypes.func.isRequired,
    modalHide: PropTypes.func.isRequired,
    modalShow: PropTypes.func.isRequired,
    personalinfos: PropTypes.object.isRequired,
    routes: PropTypes.instanceOf(Array),
    setCodeFilter: PropTypes.func.isRequired,
    setErrorMessage: PropTypes.func.isRequired,
    setLocationFilter: PropTypes.func.isRequired,
    setSelectedPartner: PropTypes.func.isRequired,
    setStatusFilter: PropTypes.func.isRequired,
  }
  static defaultProps = {
    routes: {},
    currentUser: null,
  }
  componentDidMount() {
    hasAccess(this.props.currentUser, 'ADMN: Search For Partner', this.props.history)
    this.props.getPersonalInfos(this.props.currentUser.EmployeeId)
  }

  bannerProps = () => {
    const {
      routes, history, location, match, path,
    } = this.props
    return {
      name: 'Admin centre',
      history,
      location,
      path,
      match,
      routes,
    }
  }

  handleOpenPartnerPlanStatusForm = () => {
    if (sessionStorage.getItem('SelectedPartner')) {
      const selectedPartner = JSON.parse(sessionStorage.getItem('SelectedPartner'))
      this.props.getMyPartnerPlans(selectedPartner.EmployeeId, constants.PARTNERPLAN.PLAN_FILTER_PARTNER_YEAR)
      setTimeout(() => { this.props.modalShow('partnerPlanStatusForm') }, 1000)
    } else {
      console.warn('Selected partner session is empty, please check...')
    }
  }

  handleOpenPartnerHierarchyForm = () => {
    if (sessionStorage.getItem('SelectedPartner')) {
      const selectedPartner = JSON.parse(sessionStorage.getItem('SelectedPartner'))
      this.props.loadSelectedPartnerHierarchy(this.props.currentUser.EmployeeId, selectedPartner.EmployeeId)
      setTimeout(() => { this.props.modalShow('partnerHierarchyForm') }, 1000)
    } else {
      console.warn('Selected partner session is empty, please check...')
    }
  }

  render() {
    const { routes, personalinfos } = this.props
    return (
      <div>
        <MainLayout
          bannerNavProps={{ ...this.bannerProps() }}
          currentUser={this.props.currentUser}
          modalHide={this.props.modalHide}
          modalShow={this.props.modalShow}
          sidebarType="partnerAdmin"
        >
          <Container>
            {routes.map((route, i) => (
              <RouteWithSubRoutes
                key={i}
                {...route}
                currentUser={this.props.currentUser}
                getMyPartnerPlans={this.props.getMyPartnerPlans}
                getPersonalInfos={this.props.getPersonalInfos}
                openPartnerHierarchyForm={this.handleOpenPartnerHierarchyForm} // look here
                openPartnerPlanStatusForm={this.handleOpenPartnerPlanStatusForm}
                personalinfos={personalinfos}
                setCodeFilter={this.props.setCodeFilter}
                setErrorMessage={this.props.setErrorMessage}
                setLocationFilter={this.props.setLocationFilter}
                setSelectedPartner={this.props.setSelectedPartner}
                setStatusFilter={this.props.setStatusFilter}
              />
          ))}
          </Container>
          <PartnerPlanStatusForm currentUser={this.props.currentUser} hide={this.props.modalHide} partnerPlans={this.props.partnerPlans} />
          <PartnerHierarchyForm currentUserId={this.props.currentUser.EmployeeId} hide={this.props.modalHide} />
        </MainLayout>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  personalinfos: state.personalinfos,
  partnerPlans: state.partnerPlans,
  partnerPlanForm: state.partnerPlanForm,
  partnerSideBarInfo: state.app.partnerSideBarInfo,
})

export default withRouter(connect(mapStateToProps, {
  resetErrorMessage,
  setErrorMessage,
  getMyPartnerPlans,
  getPersonalInfos,
  loadSelectedPartnerHierarchy,
  setStatusFilter,
  setCodeFilter,
  setLocationFilter,
  setSelectedPartner,
  modalShow,
  modalHide,
})(PersonalInfos))



// WEBPACK FOOTER //
// ./src/containers/PersonalInfos.js